import { Svg } from "chartist";

export function writeValueInsideBar(data, locale, prefix, suffix, transformFn = null, verticalOrientation = false, targetCircle){
    if (data.type === 'bar') {
        let barWidth = 40;
        let origin_x = ""
        
        if(verticalOrientation){ 
            origin_x = (data.y1<data.y2) ? data.y1 : data.y2
        }else{
            origin_x = (data.x1<data.x2) ? data.x1 : data.x2;
        }

        let barHorizontalCenter = (origin_x + (data.element.width() * .5));
        let barVerticalCenter =  (verticalOrientation ? data.x1 : data.y1 + (barWidth * .12));
        const v = verticalOrientation ? data.value.y : data.value.x;

        const labelValue = transformFn ? transformFn(v, locale) : v.toLocaleString(locale);
        const labelText = `${prefix}${labelValue}${suffix} `;

        let label = new Svg("text");
        label.text(labelText);

        // add the new custom text label to the bar
        data.group.append(label);

        // only *now* that its been added to the bar and written to the DOM
        // can we measure it to see if it actually fits in the bar
        let barLength;
        if(verticalOrientation){
            barLength = data.y2 - data.y1
        }else{
            barLength = labelValue < 0 ? data.x1 - data.x2 : data.x2 - data.x1
        } // get the width of the bar itself
        let labelWidth = label._node.getBBox().width; // now get the width of the custom label
        // if the padded width of the label is larger than the bar...

        const calc_y = verticalOrientation ? barHorizontalCenter + 5 : barVerticalCenter - 0.3

        let calc_x
        
        if(prefix){
            calc_x = verticalOrientation ? barVerticalCenter : barHorizontalCenter - labelWidth/1.7;
        }else if(suffix){
            calc_x = verticalOrientation ? barVerticalCenter : barHorizontalCenter - labelWidth/2.3;
        } else{
            calc_x = verticalOrientation ? barVerticalCenter : barHorizontalCenter - labelWidth/2;

        }


        label.attr({
            y: calc_y,
            x: calc_x,
            "text-anchor": "center",
            style: "fill: white",
            "class":"bar-value",
            'ct:value': `${prefix}${data.value.x}${suffix}`,
            'ct:valueText': `${prefix}${data.series[data.index].valueText}${suffix}`,
            'ct:targetValueText': `${prefix}${data.series[data.index].targetValueText}${suffix}`

        });    
        


        if(!verticalOrientation){
            const labelPadding = 21;
            if ((Math.abs(labelWidth) - labelPadding ) >= Math.abs(barLength)) {
                // don't show it
                label.remove();
            }
            else if(data.series[data.index].targetValueText && (data.value.x !== 0) && targetCircle === true){
                const targetPosition = (barLength * (data.series[data.index].targetValueText / data.value.x) );
                const padding = 21;
                if(
                    (targetPosition >= ((barLength/2) - (labelWidth/2) - padding))
                    &&
                    (targetPosition <= ((barLength/2) + (labelWidth/2) + padding))
                ){
                    // don't show it
                    label.remove();
                }    
            }
        }
    }
}
